import { FC, ReactNode } from "react";
import Popup from "reactjs-popup";

interface PopupMenuProps {
    trigger: JSX.Element | ((isOpen: boolean) => JSX.Element);
    children: ReactNode;
    position?: "top left" | "top right" | "bottom left" | "bottom right";
    menuClassName?: string;
    overlayClassName?: string;
}

const PopupMenu: FC<PopupMenuProps> = ({
    trigger,
    children,
    position = "bottom right",
    menuClassName = "",
    overlayClassName = "",
}) => {
    return (
        <Popup
            trigger={trigger}
            position={position}
            closeOnDocumentClick
            arrow={false}
            overlayStyle={{ background: "transparent" }}
            contentStyle={{ padding: 0, border: "none", boxShadow: "0 2px 8px rgba(0,0,0,0.12)" }}
            className={overlayClassName}
        >
            <div
                className={`bg-white dark:bg-dark-bg-300 dark:text-dark-text-100 rounded-lg shadow-md py-2 min-w-[160px] ${menuClassName}`}
            >
                {children}
            </div>
        </Popup>
    );
};

export default PopupMenu;
